import React from 'react';
import {Chip, Tooltip} from '@mui/material';
import PropTypes from 'prop-types';
import {
  CloudUpload as UploadIcon,
  Api as ApiIcon,
  Settings as SettingsIcon,
  Cloud as CloudIcon,
  Code as CodeIcon,
} from '@mui/icons-material';

const IntegrationSourceChip = ({integration_source}) => {
  if (!integration_source) {
    return (
      <Chip
        label='Unknown'
        size='small'
        variant='outlined'
        sx={{
          backgroundColor: '#f5f5f5',
          color: '#666',
          border: '1px solid #ddd',
          fontSize: '0.75rem',
          height: '24px',
        }}
      />
    );
  }

  const getIconAndColor = (source) => {
    switch (source.toLowerCase()) {
      case 'file_upload':
        return {
          icon: <UploadIcon />,
          color: '#2196f3',
          backgroundColor: '#e3f2fd',
          borderColor: '#2196f3',
        };
      case 'zapier':
        return {
          icon: <CloudIcon />,
          color: '#ff9800',
          backgroundColor: '#fff3e0',
          borderColor: '#ff9800',
        };
      case 'make':
        return {
          icon: <SettingsIcon />,
          color: '#9c27b0',
          backgroundColor: '#f3e5f5',
          borderColor: '#9c27b0',
        };
      case 'api':
        return {
          icon: <ApiIcon />,
          color: '#4caf50',
          backgroundColor: '#e8f5e8',
          borderColor: '#4caf50',
        };
      default:
        return {
          icon: <CodeIcon />,
          color: '#607d8b',
          backgroundColor: '#eceff1',
          borderColor: '#607d8b',
        };
    }
  };

  const {icon, color, backgroundColor, borderColor} =
    getIconAndColor(integration_source);

  return (
    <Tooltip title={`Data source: ${integration_source}`}>
      <Chip
        icon={icon}
        label={integration_source.replace(/_/g, ' ').toUpperCase()}
        size='small'
        variant='outlined'
        sx={{
          color: color,
          backgroundColor: backgroundColor,
          border: `1px solid ${borderColor}`,
          fontSize: '0.75rem',
          height: '24px',
          fontWeight: '500',
          '&:hover': {
            backgroundColor: backgroundColor,
            opacity: 0.8,
          },
        }}
      />
    </Tooltip>
  );
};

IntegrationSourceChip.propTypes = {
  integration_source: PropTypes.string,
};

export default IntegrationSourceChip;
